import { createTheme } from '@mui/material/styles'

const theme = createTheme({
    palette: {
        primary: {
            main: '#01C36C',
            dark: '#00A65C',
            light: '#E9FBF2'
        }
    },
    typography: {
        fontFamily: "'Inter', Helvetica, Arial, sans-serif"
    },
    shape: {
        borderRadius: 10
    }
})

export { theme }
